// extracted by mini-css-extract-plugin
module.exports = {"buyOnlineCta":"BuyOnlineCta_buyOnlineCta__KMOVE","button":"BuyOnlineCta_button__T1o7T","or":"BuyOnlineCta_or__jB2k8","copy":"BuyOnlineCta_copy__BuxKx"};